// Bison's two offices and how to reach us, as the website's About and
// Contact pages publish them (lib/content.ts `aboutOffices`, app/contact
// phone; the info@ mailbox is the company's general inbox). Rendered at the
// foot of the Capabilities "Who we are" panel (Bill, 2026-09-08). Static
// company facts, identical in every room, so they live here rather than in
// room JSON. Photos copied from the site into public/brand/offices/.
export type Office = {
    city: string;
    label: string;
    address: string[];
    photoUrl: string;
    photoAlt: string;
};

export const OFFICES: Office[] = [
    {
        city: "Hinsdale, Illinois",
        label: "Headquarters",
        address: ["330 West Chestnut St, Suite 2W", "Hinsdale, IL 60521"],
        photoUrl: "/brand/offices/hinsdale-exterior.webp",
        photoAlt: "The Bison Commerce headquarters in Hinsdale, Illinois",
    },
    {
        city: "Kaunas, Lithuania",
        label: "Operations center",
        address: ["Veiveriu g. 90", "Kaunas, LT-46271"],
        photoUrl: "/brand/offices/hq-exterior.webp",
        photoAlt: "The Bison Commerce operations center in Kaunas, Lithuania",
    },
];

export const CONTACT = {
    phone: { display: "(800) 893-4091", href: "tel:8008934091" },
    email: "info@bisoncommerce.com",
};
